export const HospitalsList = [
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
  {
    hospitalName: "Virginia Mason Medical Center",
    location: "WA, Seattle",
    patientDischarges: "2,300",
    tags: ["Private", "General Care", "Specialty Care"],
    dischargeCount: "567",
    change: "+15 ▲",
  },
];

export const HospitalData = [
  {
    name: "New York-Presbyterian Hospital",
    state: "New York",
    zip: "10032",
    county: "New York",
  },
  { name: "Cleveland Clinic", state: "Ohio", zip: "44195", county: "Cuyahoga" },
  { name: "Mayo Clinic", state: "Minnesota", zip: "55905", county: "Olmsted" },
  {
    name: "Johns Hopkins Hospital",
    state: "Maryland",
    zip: "21287",
    county: "Baltimore",
  },
  {
    name: "Massachusetts General Hospital",
    state: "Massachusetts",
    zip: "02114",
    county: "Suffolk",
  },
  {
    name: "Los Angeles County Hospital",
    state: "California",
    zip: "90033",
    county: "Los Angeles",
  },
  {
    name: "Cook County Hospital",
    state: "Illinois",
    zip: "60612",
    county: "Cook",
  },
  {
    name: "Houston Methodist Hospital",
    state: "Texas",
    zip: "77030",
    county: "Harris",
  },
  {
    name: "Seattle Children's Hospital",
    state: "Washington",
    zip: "98105",
    county: "King",
  },
  {
    name: "UCSF Medical Center",
    state: "California",
    zip: "94143",
    county: "San Francisco",
  },
];

export const AdvancedFilterMap = [
  {
    category: "Location",
    fields: [
      { type: "input", placeholder: "Enter Hospital or System Name" },
      { type: "dropdown", placeholder: "Select CBSA" },
      { type: "input", placeholder: "Enter Zip Code" },
      { type: "dropdown", placeholder: "Select State" },
      { type: "dropdown", placeholder: "Select County" },
      { type: "divider" },
      { type: "checkbox", label: "Urban" },
      { type: "checkbox", label: "Rural" },
    ],
  },
  {
    category: "Facilities",
    fields: [
      { type: "dropdown", placeholder: "Select Facility Type" },
      { type: "dropdown", placeholder: "Select Ownership Type" },
      { type: "dropdown", placeholder: "Select Hospital Flags" },
      { type: "divider" },
      { type: "slider", title: "Bed Count", min: 0, max: 500 },
      { type: "slider", title: "Square Footage", min: 0, max: 500 },
      { type: "slider", title: "Patient Discharge Volumne", min: 0, max: 500 },
      { type: "slider", title: "Total Cases", min: 0, max: 500 },
    ],
  },
  {
    category: "Oncology Focus",
    fields: [
      { type: "checkbox", label: "Radiation Oncology" },
      { type: "checkbox", label: "Palliative Care" },
      { type: "checkbox", label: "Genomics Sevices" },
      { type: "checkbox", label: "Surgical Oncology" },
      { type: "checkbox", label: "Survivorship Programs" },
      { type: "checkbox", label: "Tumor Board" },
      { type: "checkbox", label: "Precision Oncology Program" },
      { type: "checkbox", label: "SCT or BMT Services" },
      { type: "checkbox", label: "Participtaion in Clinal Trials" },
      { type: "checkbox", label: "Chemotherapy Infusion Centers" },
      { type: "checkbox", label: "Proton Therapy Services" },
      { type: "checkbox", label: "Research Affiliations" },
    ],
  },
  {
    category: "Financial & Operational",
    fields: [
      { type: "slider", title: "Gross Revenue", main: 0, max: 500 },
      { type: "slider", title: "Operating Margins", main: 0, max: 500 },
      {
        type: "slider",
        title: "Revenue to Cost Ratio Threshold",
        main: 0,
        max: 500,
      },
      { type: "slider", title: "Bad Debt Percentage", main: 0, max: 500 },
      {
        type: "slider",
        title: "Oncology Treatment Revenue",
        main: 0,
        max: 500,
      },
      {
        type: "slider",
        title: "Medicare Oncology Spending",
        main: 0,
        max: 500,
      },
    ],
  },
  {
    category: "Reputation",
    fields: [
      { type: "checkbox", label: "Teaching Hospital" },
      { type: "checkbox", label: "News Feed Mentions" },
      { type: "checkbox", label: "Medical Publications" },
    ],
  },
  {
    category: "Affiliations",
    fields: [
      { type: "checkbox", label: "Medical Teaching Affiliations" },
      { type: "checkbox", label: "Industry Partnerships" },
      { type: "checkbox", label: "Cancer Research Affiliations" },
    ],
  },
  {
    category: "Accreditations",
    fields: [
      { type: "checkbox", label: "COC Accredited" },
      { type: "checkbox", label: "NCI Accredited" },
      { type: "checkbox", label: "Joint Commission Accredited" },
    ],
  },
  {
    category: "Quality of Care",
    fields: [
      { type: "dropdown", placeholder: "Select Readmission Rate" },
      { type: "dropdown", placeholder: "Select Oncology Mortality Rates" },
      { type: "divider" },
      { type: "checkbox", label: "CMS Rating" },
      { type: "checkbox", label: "QOPI Ratings" },
      { type: "checkbox", label: "HCAHPS Rating" },
      { type: "checkbox", label: "Vizient Ratings" },
      { type: "checkbox", label: "NSQIP Ratings" },
    ],
  },
  {
    category: "Patient Experience",
    fields: [
      { type: "dropdown", placeholder: "Select Patient Amenities" },
      {
        type: "slider",
        title: "Communication with Nurses/Doctors",
        min: "Low",
        max: "Excellent",
      },
      {
        type: "slider",
        title: "Appointment Wait Time",
        min: "Low",
        max: "Excellent",
      },
      {
        type: "slider",
        title: "Cleanliness and Quitness Ratings",
        min: "0",
        max: "5",
      },
      { type: "divider" },
      { type: "checkbox", label: "Likelihood of recommendation" },
      { type: "checkbox", label: "Cancer Navigation Programs" },
      { type: "checkbox", label: "Wellness Programs" },
    ],
  },
  {
    category: "Accessibility & Inclusivity",
    fields: [
      { type: "checkbox", label: "Language Assistance Services" },
      { type: "checkbox", label: "Oncology Aid Programs" },
      { type: "checkbox", label: "Urban Area Accessibility" },
      { type: "checkbox", label: "Rural Area Accessibility" },
    ],
  },
  {
    category: "Search History",
  },
];

export const table = {
  data: [
    {
      "Sr.": 1,
      "hospital name": "Overlake Hospital",
      location: "WA, Bellevue",
      "ownership type": "Voluntary Non Profit",
      "no. of beds.": "1,234",
      "patient discharges": "1,900",
      "gross revenue": "$ 1.2B",
      accreditations: "COC +2",
      "cms rating": "4.5☆",
      ranking: 1,
      slider: "",
      share: "",
      bookmark: "",
    },
    {
      "Sr.": 2,
      "hospital name": "St. Joseph Medical Center",
      location: "WA, Bellingham",
      "ownership type": "Non Profit",
      "no. of beds.": "1,234",
      "patient discharges": "1,900",
      "gross revenue": "$ 1.2B",
      accreditations: "COC +2",
      "cms rating": "4.5☆",
      ranking: 2,
      slider: "",
      share: "",
      bookmark: "",
    },
    {
      "Sr.": 3,
      "hospital name": "Overlake Hospital",
      location: "WA, Bellevue",
      "ownership type": "Voluntary Non Profit",
      "no. of beds.": "1,234",
      "patient discharges": "1,900",
      "gross revenue": "$ 1.2B",
      accreditations: "COC +2",
      "cms rating": "4.5☆",
      ranking: 3,
      slider: "",
      share: "",
      bookmark: "",
    },
    {
      "Sr.": 4,
      "hospital name": "St. Joseph Medical Center",
      location: "WA, Bellingham",
      "ownership type": "Non Profit",
      "no. of beds.": "1,234",
      "patient discharges": "1,900",
      "gross revenue": "$ 1.2B",
      accreditations: "COC +2",
      "cms rating": "4.5☆",
      ranking: 4,
      slider: "",
      share: "",
      bookmark: "",
    },
    {
      "Sr.": 5,
      "hospital name": "Overlake Hospital",
      location: "WA, Bellevue",
      "ownership type": "Voluntary Non Profit",
      "no. of beds.": "1,234",
      "patient discharges": "1,900",
      "gross revenue": "$ 1.2B",
      accreditations: "COC +2",
      "cms rating": "4.5☆",
      ranking: 5,
      slider: "",
      share: "",
      bookmark: "",
    },
    {
      "Sr.": 6,
      "hospital name": "St. Joseph Medical Center",
      location: "WA, Bellingham",
      "ownership type": "Non Profit",
      "no. of beds.": "1,234",
      "patient discharges": "1,900",
      "gross revenue": "$ 1.2B",
      accreditations: "COC +2",
      "cms rating": "4.5☆",
      ranking: 6,
      slider: "",
      share: "",
      bookmark: "",
    },
    {
      "Sr.": 7,
      "hospital name": "Overlake Hospital",
      location: "WA, Bellevue",
      "ownership type": "Voluntary Non Profit",
      "no. of beds.": "1,234",
      "patient discharges": "1,900",
      "gross revenue": "$ 1.2B",
      accreditations: "COC +2",
      "cms rating": "4.5☆",
      ranking: 7,
      slider: "",
      share: "",
      bookmark: "",
    },
    {
      "Sr.": 8,
      "hospital name": "St. Joseph Medical Center",
      location: "WA, Bellingham",
      "ownership type": "Non Profit",
      "no. of beds.": "1,234",
      "patient discharges": "1,900",
      "gross revenue": "$ 1.2B",
      accreditations: "COC +2",
      "cms rating": "4.5☆",
      ranking: 8,
      slider: "",
      share: "",
      bookmark: "",
    },
    {
      "Sr.": 9,
      "hospital name": "Overlake Hospital",
      location: "WA, Bellevue",
      "ownership type": "Voluntary Non Profit",
      "no. of beds.": "1,234",
      "patient discharges": "1,900",
      "gross revenue": "$ 1.2B",
      accreditations: "COC +2",
      "cms rating": "4.5☆",
      ranking: 9,
      slider: "",
      share: "",
      bookmark: "",
    },
    {
      "Sr.": 10,
      "hospital name": "St. Joseph Medical Center",
      location: "WA, Bellingham",
      "ownership type": "Non Profit",
      "no. of beds.": "1,234",
      "patient discharges": "1,900",
      "gross revenue": "$ 1.2B",
      accreditations: "COC +2",
      "cms rating": "4.5☆",
      ranking: 10,
      slider: "",
      share: "",
      bookmark: "",
    },
    {
      "Sr.": 11,
      "hospital name": "Overlake Hospital",
      location: "WA, Bellevue",
      "ownership type": "Voluntary Non Profit",
      "no. of beds.": "1,234",
      "patient discharges": "1,900",
      "gross revenue": "$ 1.2B",
      accreditations: "COC +2",
      "cms rating": "4.5☆",
      ranking: 11,
      slider: "",
      share: "",
      bookmark: "",
    },
    {
      "Sr.": 12,
      "hospital name": "St. Joseph Medical Center",
      location: "WA, Bellingham",
      "ownership type": "Non Profit",
      "no. of beds.": "1,234",
      "patient discharges": "1,900",
      "gross revenue": "$ 1.2B",
      accreditations: "COC +2",
      "cms rating": "4.5☆",
      ranking: 12,
      slider: "",
      share: "",
      bookmark: "",
    },
    {
      "Sr.": 13,
      "hospital name": "Overlake Hospital",
      location: "WA, Bellevue",
      "ownership type": "Voluntary Non Profit",
      "no. of beds.": "1,234",
      "patient discharges": "1,900",
      "gross revenue": "$ 1.2B",
      accreditations: "COC +2",
      "cms rating": "4.5☆",
      ranking: 13,
      slider: "",
      share: "",
      bookmark: "",
    },
  ],
  columns: [
    { header: "Sr.", accessor: "Sr.", sortedBy: "", order: "desc" },
    {
      header: "Hospital Name",
      accessor: "hospital name",
      sortedBy: "hosp10_name",
      order: "desc",
    },
    {
      header: "Location",
      accessor: "location",
      sortedBy: "state",
      order: "desc",
    },
    {
      header: "Ownership Type",
      accessor: "ownership type",
      sortedBy: "prov_control_type",
      order: "desc",
    },
    {
      header: "No. of Beds.",
      accessor: "no. of beds.",
      sortedBy: "CALC_STATS_BEDS_TOTAL",
      order: "desc",
    },
    {
      header: "Patient Discharges",
      accessor: "patient discharges",
      sortedBy: "CALC_STATS_ADJ_PT_DISCHARGE",
      order: "desc",
    },
    {
      header: "Net Patient Revenue",
      accessor: "net patient revenue",
      sortedBy: "NET_PATIENT_REVENUE",
      order: "desc",
    },
    {
      header: "Accreditations",
      accessor: "accreditations",
      sortedBy: "accreditation_count",
      order: "desc",
    },
    {
      header: "Overall Rating",
      accessor: "cms rating",
      sortedBy: "overall_rating",
      order: "desc",
    },
    {
      header: "Ranking",
      accessor: "ranking",
      sortedBy: "RANKING",
      order: "desc",
    },
    { header: "", accessor: "slider", sortedBy: "", order: "desc" },
    { header: "", accessor: "bookmark", sortedBy: "", order: "desc" },
  ],
};

export const cbsaList = [
  "36420",
  "35620",
  "16980",
  "36740",
  "26420",
  "19780",
  "43620",
  "35300",
  "48620",
  "33100",
  "41700",
  "19740",
  "10420",
  "10900",
  "37980",
  "33340",
  "31180",
  "28140",
  "27140",
  "33460",
  "25420",
  "41060",
  "38500",
  "41740",
  "29100",
  "26620",
  "44180",
  "48900",
  "10500",
  "40140",
  "23580",
  "30140",
  "31900",
  "42660",
  "20500",
  "39580",
  "31140",
  "28740",
  "15940",
  "31080",
  "32580",
  "14860",
  "17140",
  "22500",
  "36540",
  "42540",
  "19100",
  "19430",
  "36220",
  "44060",
  "12940",
  "41180",
  "38060",
  "45300",
  "35380",
  "22900",
  "19260",
  "21660",
  "28420",
  "12420",
  "25500",
  "39900",
  "40420",
  "44100",
  "41620",
  "13140",
  "19820",
  "27740",
  "14460",
  "28700",
  "49420",
  "41780",
  "45060",
  "41420",
  "14020",
  "33860",
  "22420",
  "49660",
  "12580",
  "40380",
  "29180",
  "47580",
  "11100",
  "39500",
  "24540",
  "37460",
  "24020",
  "24300",
  "22020",
  "12060",
  "31700",
  "13820",
  "13780",
  "42620",
  "12540",
  "44700",
  "34980",
  "10100",
  "29700",
  "47900",
  "26900",
  "33540",
  "17300",
  "14740",
  "26580",
  "36100",
  "38300",
  "17980",
  "39740",
  "10740",
  "32380",
  "41940",
  "39380",
  "21340",
  "33660",
  "41860",
  "44580",
  "46060",
  "27620",
  "16740",
  "34780",
  "40060",
  "17460",
  "21820",
  "10700",
  "40220",
  "20220",
  "44620",
  "38860",
  "38580",
  "22300",
  "13740",
  "42300",
  "12260",
  "24660",
  "38180",
  "23460",
  "33500",
  "18420",
  "15740",
  "11220",
  "30700",
  "46060",
  "32100",
  "42140",
  "26380",
  "25780",
  "27260",
  "22380",
  "25740",
  "40900",
  "29020",
  "38940",
  "35840",
  "25540",
  "39100",
  "29820",
  "30940",
  "39300",
  "43340",
  "31500",
  "44220",
  "10980",
  "25460",
  "27980",
  "26820",
  "39460",
  "38260",
  "14220",
  "25620",
  "22180",
  "34900",
  "16580",
  "13460",
  "41980",
  "20820",
  "45780",
  "40260",
  "34660",
  "26780",
  "43140",
  "34820",
  "38620",
  "36260",
  "37800",
  "32260",
  "42100",
  "30780",
  "29460",
  "37540",
  "45180",
  "18140",
  "33020",
  "48540",
  "47700",
  "39980",
  "34100",
  "29540",
  "49220",
  "12620",
  "33700",
  "37900",
  "10540",
  "49340",
  "19660",
  "49180",
  "16860",
  "25720",
  "39820",
  "31420",
  "30020",
  "17260",
  "25840",
  "15180",
  "48940",
  "11980",
  "24420",
  "32820",
  "13660",
  "24860",
  "32940",
  "28540",
  "14420",
  "46020",
  "46100",
  "20580",
  "15580",
  "30820",
  "25940",
  "16540",
  "44780",
  "32460",
  "13220",
  "32340",
  "19060",
  "35580",
  "43500",
  "10300",
  "44860",
  "12980",
  "33940",
  "49340",
  "40080",
  "37340",
  "16500",
  "31340",
  "47920",
  "37740",
  "42340",
  "16700",
  "22100",
  "37420",
  "20260",
  "21460",
  "33380",
  "28620",
  "41500",
  "33180",
  "16300",
  "24180",
  "26980",
  "45020",
  "43940",
  "28580",
  "44020",
  "46780",
  "25760",
  "45460",
  "49620",
  "47260",
  "25200",
  "29980",
  "46540",
  "35440",
  "38100",
  "29380",
  "43620",
  "23420",
  "46140",
  "22340",
  "18500",
  "11780",
  "47300",
  "15420",
  "39660",
  "21780",
  "41660",
  "18580",
  "15340",
  "16620",
  "34700",
  "11020",
  "25180",
  "48700",
  "10780",
  "30900",
  "49700",
  "27160",
  "19700",
  "24460",
  "39860",
  "31620",
  "17900",
  "29620",
  "27900",
  "20100",
  "43580",
  "17820",
  "14300",
  "41900",
  "30460",
  "30860",
  "45220",
  "37460",
  "40340",
  "37860",
  "40700",
  "10180",
  "40780",
  "22020",
  "12620",
  "43420",
  "20740",
  "28660",
  "37770",
  "24580",
  "14260",
  "24380",
  "16220",
  "29200",
  "49660",
  "45520",
  "26220",
  "26140",
  "18380",
  "37260",
  "32000",
  "39220",
  "49700",
  "33260",
  "40580",
  "27780",
  "12700",
  "46340",
  "35740",
  "24260",
  "29340",
  "22220",
  "11700",
  "19220",
  "13900",
  "25900",
  "40980",
  "46900",
  "11460",
  "25880",
  "48660",
];

export const stateList = [
  "AK",
  "AL",
  "AR",
  "AZ",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "IA",
  "ID",
  "IL",
  "IN",
  "KS",
  "KY",
  "LA",
  "MA",
  "MD",
  "ME",
  "MI",
  "MN",
  "MO",
  "MS",
  "MT",
  "NC",
  "ND",
  "NE",
  "NH",
  "NJ",
  "NM",
  "NV",
  "NY",
  "OH",
  "OK",
  "OR",
  "PA",
  "PR",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VA",
  "VI",
  "VT",
  "WA",
  "WI",
  "WV",
  "WY",
];

export const StateAbbrvToName = {
  "AK": "Alaska",
  "AL": "Alabama",
  "AR": "Arkansas",
  "AZ": "Arizona",
  "CA": "California",
  "CO": "Colorado",
  "CT": "Connecticut",
  "DE": "Delaware",
  "FL": "Florida",
  "GA": "Georgia",
  "HI": "Hawaii",
  "IA": "Iowa",
  "ID": "Idaho",
  "IL": "Illinois",
  "IN": "Indiana",
  "KS": "Kansas",
  "KY": "Kentucky",
  "LA": "Louisiana",
  "MA": "Massachusetts",
  "MD": "Maryland",
  "ME": "Maine",
  "MI": "Michigan",
  "MN": "Minnesota",
  "MO": "Missouri",
  "MS": "Mississippi",
  "MT": "Montana",
  "NC": "North Carolina",
  "ND": "North Dakota",
  "NE": "Nebraska",
  "NH": "New Hampshire",
  "NJ": "New Jersey",
  "NM": "New Mexico",
  "NV": "Nevada",
  "NY": "New York",
  "OH": "Ohio",
  "OK": "Oklahoma",
  "OR": "Oregon",
  "PA": "Pennsylvania",
  "PR": "Puerto Rico",
  "RI": "Rhode Island",
  "SC": "South Carolina",
  "SD": "South Dakota",
  "TN": "Tennessee",
  "TX": "Texas",
  "UT": "Utah",
  "VA": "Virginia",
  "VI": "Virgin Islands",
  "VT": "Vermont",
  "WA": "Washington",
  "WI": "Wisconsin",
  "WV": "West Virginia",
  "WY": "Wyoming"
};

export const fullStateList = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  VI: "Virgin Islands",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
};

export const zipCodeList = [
  "73104",
  "10467",
  "60045",
  "32803",
  "60153",
  "77030",
  "50309",
  "77008",
  "57105",
  "6504",
  "67214",
  "33136",
  "78229",
  "80045",
  "44308",
  "18015",
  "19104",
  "53210",
  "10016",
  "79410",
  "64108",
  "39216",
  "55404",
  "17033",
  "56303",
  "46563",
  "92103",
  "54601",
  "35801",
  "65804",
  "28402",
  "31701",
  "92354",
  "30501",
  "17064",
  "44903",
  "98195",
  "19141",
  "27710",
  "27607",
  "40202",
  "12401",
  "44710",
  "92868",
  "8901",
  "78539",
  "11355",
  "60637",
  "45220",
  "7112",
  "98105",
  "64132",
  "92658",
  "29506",
  "98405",
  "68114",
  "91328",
  "18702",
  "75203",
  "44708",
  "45431",
  "79761",
  "99220",
  "70809",
  "63110",
  "60126",
  "63128",
  "85016",
  "33613",
  "70112",
  "72917",
  "24541",
  "97477",
  "99352",
  "78758",
  "22801",
  "89502",
  "61104",
  "62781",
  "84113",
  "77701",
  "7753",
  "37604",
  "2129",
  "37662",
  "92411",
  "60515",
  "19010",
  "98902",
  "40207",
  "44870",
  "7652",
  "2148",
  "13210",
  "97301",
  "47402",
  "36106",
  "45405",
  "48503",
  "44483",
  "33137",
  "21061",
  "14626",
  "70503",
  "31093",
  "80218",
  "79106",
  "62301",
  "80631",
  "60402",
  "32401",
  "12801",
  "81502",
  "91367",
  "55102",
  "60625",
  "58103",
  "30329",
  "3103",
  "35213",
  "13905",
  "72143",
  "93303",
  "68124",
  "95204",
  "37207",
  "57402",
  "78041",
  "21701",
  "60005",
  "46256",
  "27704",
  "11576",
  "60525",
  "2238",
  "59802",
  "37620",
  "46350",
  "42240",
  "3820",
  "73109",
  "18411",
  "98310",
  "25701",
  "34474",
  "15009",
  "31902",
  "48439",
  "19603",
  "87102",
  "21204",
  "50401",
  "45005",
  "22191",
  "95051",
  "81004",
  "11215",
  "21225",
  "79902",
  "7666",
  "36604",
  "14621",
  "18510",
  "20904",
  "22401",
  "77338",
  "94520",
  "61081",
  "33770",
  "85741",
  "65102",
  "98004",
  "28025",
  "74401",
  "23805",
  "44035",
  "94117",
  "60123",
  "46307",
  "99701",
  "35957",
  "62002",
  "24153",
  "52001",
  "37066",
  "54481",
  "76015",
  "85375",
  "53142",
  "45631",
  "44129",
  "21045",
  "45840",
  "42241",
  "60657",
  "59101",
  "49783",
  "41501",
  "34119",
  "91405",
  "30909",
  "60506",
  "84124",
  "47150",
  "27260",
  "76104",
  "35211",
  "63119",
  "92037",
  "95116",
  "57501",
  "35903",
  "33484",
  "46016",
  "58702",
  "38834",
  "43750",
  "12010",
  "68506",
  "76028",
  "8724",
  "85745",
  "19152",
  "49855",
  "87505",
  "19460",
  "77504",
  "85251",
  "53051",
  "78503",
  "22033",
  "70301",
  "27536",
  "15650",
  "32073",
  "75067",
  "52057",
  "20110",
  "33016",
  "45069",
  "73120",
  "86001",
  "59601",
  "84065",
  "95608",
  "46902",
  "74534",
  "34950",
  "34208",
  "8015",
  "34667",
  "12550",
  "89119",
  "21201",
  "93302",
  "40741",
  "34601",
  "11772",
  "66112",
  "33609",
  "71101",
  "88310",
  "47250",
  "45504",
  "46227",
  "49707",
  "10029",
  "72601",
  "96793",
  "83404",
  "33952",
  "2721",
  "45342",
  "94109",
  "30076",
  "66762",
  "70427",
  "39402",
  "28334",
  "94558",
  "91402",
  "19320",
  "23970",
  "56501",
  "94577",
  "95076",
  "30097",
  "84094",
  "61801",
  "97701",
  "936",
  "62401",
  "43402",
  "27870",
  "33541",
  "42071",
  "33033",
  "46714",
  "55336",
  "28150",
  "29569",
  "74601",
  "84041",
  "24592",
  "50219",
  "50158",
  "11213",
  "11901",
  "48060",
  "91356",
  "95065",
  "92373",
  "20832",
  "72034",
  "75093",
  "33837",
  "38242",
  "44310",
  "23860",
  "35150",
  "92023",
  "43228",
  "33544",
  "95823",
  "65265",
  "43935",
  "35023",
  "72205",
  "46580",
  "66211",
  "10512",
  "55379",
  "20650",
  "30014",
  "24073",
  "20678",
  "92708",
  "47392",
  "37814",
  "4769",
  "92307",
  "17522",
  "54495",
  "95382",
  "19128",
  "61747",
  "33470",
  "97321",
  "76086",
  "20186",
  "32168",
  "27292",
  "49412",
  "20646",
  "37405",
  "84060",
  "96049",
  "94509",
  "48763",
  "31210",
  "75218",
  "73505",
  "38614",
  "49058",
  "4730",
  "97838",
  "78520",
  "45177",
  "75751",
  "97527",
  "91778",
  "13815",
  "49307",
  "29325",
  "39301",
  "99901",
  "44011",
  "77090",
  "801",
  "94553",
  "55109",
  "74820",
  "29681",
  "96160",
  "56013",
  "4938",
  "37388",
  "78852",
  "33564",
  "59701",
  "77478",
  "17745",
  "29902",
  "39042",
  "11787",
  "29651",
  "23901",
  "7823",
  "32068",
  "97850",
  "17268",
  "85032",
  "43015",
  "49093",
  "42066",
  "90801",
  "25136",
  "64468",
  "15425",
  "21502",
  "60521",
  "5855",
  "56073",
  "30143",
  "88061",
  "49221",
  "75482",
  "24457",
  "49068",
  "73159",
];

export const countiesList = [
  "OKLAHOMA",
  "BRONX",
  "LAKE",
  "ORANGE",
  "COOK",
  "HARRIS",
  "POLK",
  "MINNEHAHA",
  "NEW HAVEN",
  "SEDGWICK",
  "MIAMI-DADE",
  "BEXAR",
  "ADAMS",
  "SUMMIT",
  "LEHIGH",
  "PHILADELPHIA",
  "MILWAUKEE",
  "NEW YORK",
  "LUBBOCK",
  "JACKSON",
  "HINDS",
  "HENNEPIN",
  "DAUPHIN",
  "STEARNS",
  "MARSHALL",
  "SAN DIEGO",
  "LA CROSSE",
  "MADISON",
  "GREENE",
  "NEW HANOVER",
  "DOUGHERTY",
  "SAN BERNARDINO",
  "HALL",
  "LEBANON",
  "RICHLAND",
  "KING",
  "DURHAM",
  "WAKE",
  "JEFFERSON",
  "ULSTER",
  "STARK",
  "MIDDLESEX",
  "HIDALGO",
  "FAIRFIELD",
  "QUEENS",
  "HAMILTON",
  "ESSEX",
  "FLORENCE",
  "PIERCE",
  "DOUGLAS",
  "LOS ANGELES",
  "LUZERNE",
  "DALLAS",
  "ECTOR",
  "SPOKANE",
  "EAST BATON ROUGE PARISH",
  "ST. LOUIS",
  "DUPAGE",
  "MARICOPA",
  "HILLSBOROUGH",
  "ORLEANS PARISH",
  "SEBASTIAN",
  "PITTSYLVANIA",
  "LANE",
  "BENTON",
  "TRAVIS",
  "ROCKINGHAM",
  "WASHOE",
  "WINNEBAGO",
  "SANGAMON",
  "SALT LAKE",
  "MONMOUTH",
  "OAKLAND",
  "WASHINGTON",
  "SULLIVAN",
  "MONTGOMERY",
  "YAKIMA",
  "ERIE",
  "BERGEN",
  "ONONDAGA",
  "MARION",
  "MONROE",
  "GENESEE",
  "TRUMBULL",
  "ANNE ARUNDEL",
  "LAFAYETTE PARISH",
  "HOUSTON",
  "DENVER",
  "POTTER",
  "WELD",
  "BAY",
  "WARREN",
  "MESA",
  "RAMSEY",
  "CASS",
  "FULTON",
  "BROOME",
  "WHITE",
  "KERN",
  "SAN JOAQUIN",
  "DAVIDSON",
  "BROWN",
  "WEBB",
  "FREDERICK",
  "NASSAU",
  "MISSOULA",
  "LA PORTE",
  "CHRISTIAN",
  "STRAFFORD",
  "OKLAHOMA COUNTY",
  "LACKAWANNA",
  "KITSAP",
  "CABELL",
  "BEAVER",
  "MUSCOGEE",
  "BERKS",
  "BERNALILLO",
  "BALTIMORE",
  "CERRO GORDO",
  "PRINCE WILLIAM",
  "SANTA CLARA",
  "PUEBLO",
  "KINGS",
  "BALTIMORE CITY",
  "EL PASO",
  "MOBILE",
  "SPOTSYLVANIA",
  "CONTRA COSTA",
  "WHITESIDE",
  "PINELLAS",
  "PIMA",
  "COLE",
  "CABARRUS",
  "MUSKOGEE",
  "PETERSBURG CITY",
  "LORAIN",
  "SAN FRANCISCO",
  "KANE",
  "SARPY",
  "NORTH STAR BOROUGH",
  "ROANOKE",
  "DUBUQUE",
  "SUMNER",
  "PORTAGE",
  "TARRANT",
  "CUMBERLAND",
  "KENOSHA",
  "GALLIA",
  "CUYAHOGA",
  "HOWARD",
  "HANCOCK",
  "YELLOWSTONE",
  "CHIPPEWA",
  "PIKE",
  "COLLIER",
  "RICHMOND",
  "FLOYD",
  "GUILFORD",
  "HUGHES",
  "ETOWAH",
  "PALM BEACH",
  "WARD",
  "ALCORN",
  "LANCASTER",
  "OCEAN",
  "MARQUETTE",
  "SANTA FE",
  "CHESTER",
  "WAUKESHA",
  "FAIRFAX",
  "LAFOURCHE PARISH",
  "VANCE",
  "WESTMORELAND",
  "CLAY",
  "DENTON",
  "DELAWARE",
  "BUTLER",
  "COCONINO",
  "LEWIS AND CLARK",
  "SACRAMENTO",
  "STEPHENS",
  "ST. LUCIE",
  "MANATEE",
  "HARTFORD",
  "BURLINGTON",
  "PASCO",
  "LAS VEGAS",
  "SUFFOLK",
  "LAUREL",
  "BRISTOL",
  "HERNANDO",
  "WYANDOTTE",
  "HILLSBOURGH",
  "CADDO PARISH",
  "OTERO",
  "CLARK",
  "ALPENA",
  "BOONE",
  "MAUI",
  "BONNEVILLE",
  "CHARLOTTE",
  "CRAWFORD",
  "WASHINGTON PARISH",
  "LAMAR",
  "HARNETT",
  "NAPA",
  "MECKLENBURG",
  "BECKER",
  "ALAMEDA",
  "SANTA CRUZ",
  "KNOX",
  "CHAMPAIGN",
  "DESCHUTES",
  "SAN JUAN MUNICIPIO",
  "EFFINGHAM",
  "WOOD",
  "HALIFAX",
  "CALLOWAY",
  "WELLS",
  "MCLEOD",
  "CLEVELAND",
  "HORRY",
  "KAY",
  "DAVIS",
  "FAULKNER",
  "COLLIN",
  "HENRY",
  "HOPEWELL CITY",
  "TALLADEGA",
  "FRANKLIN",
  "AUDRAIN",
  "BELMONT",
  "PULASKI",
  "KOSCIUSKO",
  "JOHNSON",
  "PUTNAM",
  "SCOTT",
  "ST. MARY'S",
  "NEWTON",
  "CALVERT",
  "HAMBLEN",
  "AROOSTOOK",
  "YORK",
  "PENOBSCOT",
  "STANISLAUS",
  "TAZEWELL",
  "LINN",
  "ST. CLAIR",
  "PARKER",
  "WINDHAM",
  "FAUQUIER",
  "VOLUSIA",
  "PRINCE GEORGES",
  "NEWAYGO",
  "CHARLES",
  "SHASTA",
  "IOSCO",
  "BIBB",
  "COMANCHE",
  "COAHOMA",
  "BARRY",
  "UMATILLA",
  "CAMERON",
  "CLINTON",
  "HENDERSON",
  "JOSEPHINE",
  "OXFORD",
  "DESOTO",
  "VERNON",
  "CHENANGO",
  "MECOSTA",
  "LAURENS",
  "LAUDERDALE",
  "KETCHIKAN GATEWAY BOROUGH",
  "PONTOTOC",
  "GREENVILLE",
  "NEVADA",
  "FARIBAULT",
  "GRAFTON",
  "COFFEE",
  "MAVERICK",
  "SILVER BOW",
  "FORT BEND",
  "BEAUFORT",
  "RANKIN",
  "SPARTANBURG",
  "CAMDEN",
  "PRINCE EDWARD",
  "DUVAL",
  "UNION",
  "ST. JOSEPH",
  "GRAVES",
  "FAYETTE",
  "NODAWAY",
  "ALLEGANY",
  "ORLEANS",
  "NESHOBA",
  "PICKENS",
  "GRANT",
  "LENAWEE",
  "HOPKINS",
  "ALLEGHANY",
  "CALHOUN",
  "MONTROSE",
  "GRUNDY",
  "DEKALB",
  "POPE",
  "APPANOOSE",
  "GEARY",
  "MIAMI",
  "WAYNE",
  "IMPERIAL",
  "BREVARD",
  "PICKAWAY",
  "BOURBON",
  "TODD",
  "LEWIS",
  "BEDFORD",
  "GILA",
  "DAWSON",
  "BAYAM—N MUNICIPIO",
  "CHARLESTON",
  "VAN BUREN",
  "CAMPBELL",
  "ROSEAU",
  "PALO PINTO",
  "YAMHILL",
  "VENTURA",
  "WASCO",
  "HOOD RIVER",
  "CITRUS",
  "CRISP",
  "KENTON",
  "CUSTER",
  "MCDOWELL",
  "CARBON",
  "ST FRANCOIS",
  "PALO ALTO",
  "JERSEY",
  "GRAY",
  "CARLTON",
  "ST. CROIX",
  "IROQUOIS",
  "BROWARD",
  "WEBSTER PARISH",
  "DARE",
  "MONTEREY",
  "BELL",
  "JONES",
  "HOOD",
  "RIVERSIDE",
  "NOLAN",
  "STODDARD",
  "DICKINSON",
  "VAN WERT",
  "CLAYTON",
  "PHILLIPS",
  "SALINE",
  "GLOUCESTER",
  "BLAINE",
  "NICHOLAS",
  "OSCEOLA",
  "HERKIMER",
  "LINCOLN",
  "SEMINOLE",
  "PEARL RIVER",
  "COVINGTON",
  "CHOWAN",
  "COLUMBIA",
  "ONEIDA",
  "ADDISON",
  "ROLETTE",
  "KOOCHICHING",
  "PRICE",
  "ROGERS",
  "BEN HILL",
  "HAWAII",
  "TRANSYLVANIA",
  "SARASOTA",
  "STEUBEN",
  "KENT",
  "ASHTABULA",
  "FRESNO",
  "TULARE",
  "POTTAWATOMIE",
  "MINIDOKA",
  "PROWERS",
  "MARIN",
  "PENNINGTON",
  "KAUFMAN",
  "COOS",
  "VANDERBURGH",
  "ROCK",
  "JEFFERSON PARISH",
  "LETCHER",
  "NUECES",
  "MUSCATINE",
  "BLAIR",
  "TAYLOR",
  "HOCKING",
  "MORGAN",
  "LYCOMING",
  "RAPIDES PARISH",
  "HEMPSTEAD",
  "WETZEL",
  "NORFOLK",
  "SOMERSET",
  "CHICKASAW",
  "MC HENRY",
  "BARRON",
  "LUNA",
  "GRAND",
  "HOLT",
  "BARTON",
  "RED RIVER PARISH",
  "GOODHUE",
  "JASPER",
  "CRAIG",
  "WRIGHT",
  "SAUNDERS",
  "YOUNG",
  "EATON",
  "WILLIAMSON",
  "SOMERVELL",
  "HUTCHINSON",
  "RANDOLPH",
  "KENT",
  "JOHNSON",
  "ST CROIX",
  "MONONA",
  "NOXUBEE",
  "TELLER",
  "MCKINLEY",
  "FANNIN",
  "FREESTONE",
  "SAN GERMAN",
  "MEDINA",
  "MCKENZIE",
  "COLUSA",
  "CLOUD",
  "TULSA",
  "WILKINSON",
  "GLADWIN",
  "CHILTON",
  "HUDSON",
  "LEON",
  "SHELBY",
  "ESCAMBIA",
  "HENRICO",
  "CLALLAM",
  "GRAYSON",
  "MOREHOUSE PARISH",
  "ROLETTE",
  "ARKANSAS",
  "YELL",
  "PENOBSCOT",
  "SEGWICK",
  "MULTNOMAH",
  "TATTNALL",
  "MARTIN",
  "LAMPASAS",
  "WALSH",
  "FRIO",
  "MERCER",
  "ADA",
  "BLECKLEY",
  "CIBOLA",
  "MCCLAIN",
  "MACON",
  "NATRONA",
  "UNICOI",
  "TIPPECANOE",
  "BOSSIER PARISH",
  "ALLEGHENY",
  "CHOCTAW",
  "FRANKLIN PARISH",
  "STONE",
  "SUTTER",
  "FALL RIVER",
  "OTOE",
  "JEFF DAVIS",
  "BOUNDARY",
  "RICE",
  "VICTORIA",
  "ACADIA PARISH",
  "FAULK",
  "MIDLAND",
  "CLEARWATER",
  "MINERAL",
  "DECATUR",
  "DAY",
  "ANSON",
  "GREGORY",
  "RUNNELS",
  "GARFIELD",
  "TETON",
  "MORRIS",
  "NASH",
  "PERSHING",
  "BUCKS",
  "CAMBRIA",
  "SAN JUAN",
  "OCEANA",
  "BARNSTABLE",
  "DIVIDE",
  "CHASE",
  "SHARKEY",
  "CAVALIER",
  "BROADWATER",
  "BAY COUNTY",
  "HUMBOLDT",
  "ROGER MILLS",
  "ST. TAMMANY PARISH",
  "CHAUTAUQUA",
  "SMITH",
  "JOHNSTON",
  "MERRICK",
  "CALCASIEU PARISH",
  "BUNCOMBE",
  "BARBER",
  "WHITLEY",
  "BOYLE",
  "MORTON",
  "ALLEGHENY",
  "KANAWHA",
  "SAGINAW",
  "LARIMER",
  "SAN MATEO",
  "MAURY",
  "GARDEN",
  "BOYD",
  "EVANS",
  "WILBARGER",
  "LUCAS",
  "WASHTENAW",
  "HILLSDALE",
  "WICHITA",
];

export const suggetionHospitalList = [
  "OU MEDICAL CENTER",
  "MONTEFIORE MEDICAL CENTER",
  "NORTHWESTERN LAKE FOREST HOSPITAL",
  "ADVENTHEALTH ORLANDO",
  "LOYOLA UNIVERSITY MEDICAL CENTER",
  "THE METHODIST HOSPITAL",
  "IOWA METHODIST MEDICAL CENTER",
  "MEMORIAL HERMANN HOSPITAL SYS",
  "AVERA MCKENNAN",
  "YALE-NEW HAVEN HOSPITAL",
  "VIA CHRISTI HOSPITAL WICHITA",
  "JACKSON MEMORIAL",
  "UNIVERSITY HEALTH SYSTEM",
  "UNIVERSITY OF CO HOSPITAL",
  "SUMMA HEALTH SYSTEM",
  "ST. LUKES HOSPITAL",
  "HOSPITAL OF THE UNIV OF PENNA",
  "ASCENSION SE WISCONSIN HOSPITAL INC",
  "BELLEVUE HOSPITAL CENTER",
  "COVENANT MEDICAL CENTER",
  "CHILDRENS MERCY HOSPITAL",
  "UNIVERSITY OF MISSISSIPPI MEDICAL",
  "CHILDRENS HEALTH CARE",
  "MILTON S. HERSHEY MEDICAL CENTER",
  "ST. CLOUD HOSPITAL",
  "ST. JOSEPHS REG MED CENTER PLYMOUTH",
  "UCSD MEDICAL CENTER",
  "GUNDERSEN LUTHERAN MEDICAL CENTER I",
  "HUNTSVILLE HOSPITAL",
  "MERCY HOSPITAL SPRINGFIELD",
  "NEW HANOVER REGIONAL MEDICAL CENTER",
  "PHOEBE PUTNEY MEMORIAL HOSPITAL",
  "LOMA LINDA UNIVERSITY MEDICAL CENTER",
  "NORTHEAST GEORGIA MEDICAL CENTER",
  "PHILHAVEN",
  "MEDCENTRAL HEALTH SYSTEM",
  "UNIVERSITY OF WASHINGTON MED CTR",
  "ALBERT EINSTEIN MEDICAL CENTER",
  "DUKE UNIVERSITY HOSPITAL",
  "REX HOSPITAL",
  "UOFL HEALTH - LOUISVILLE",
  "BENEDICTINE HOSPITAL",
  "AULTMAN HOSPITAL",
  "CHILDRENS HOSPITAL OF ORANGE COUNT",
  "ROBERT WOOD JOHNSON UNIVERSITY HOSPI",
  "DOCTORS HOSPITAL AT RENAISSANCE",
  "DANBURY HOSPITAL",
  "FLUSHING HOSPITAL MEDICAL CENTER",
  "UNIVERSITY OF CHICAGO HOSPITALS",
  "GOOD SAMARITAN HOSPITAL",
  "NEWARK BETH ISRAEL MEDICAL CENTER",
  "SEATTLE CHILDRENS HOSPITAL",
  "RESEARCH MEDICAL CENTER",
  "HOAG MEMORIAL HOSPITAL PRESBYTERIAN",
  "MCLEOD REGIONAL MEDICAL CENTER",
  "ST. PETERS UNIVERSITY HOSPITAL",
  "TACOMA GENERAL ALLENMORE HOSPITAL",
  "NEBRASKA METHODIST HOSPITAL",
  "NORTHRIDGE MEDICAL CENTER - ROSCOE",
  "GEISINGER WYOMING VALLEY MED CTR",
  "METHODIST DALLAS MEDICAL CENTER",
  "CCF MERCY MEDICAL CENTER",
  "SOIN MEDICAL CENTER",
  "UCI MEDICAL CENTER",
  "MEDICAL CENTER HEALTH SYSTEM",
  "PROV SACRED HEART MEDICAL CENTER",
  "BATON ROUGE GENERAL",
  "ST. LOUIS CHILDRENS HOSPITAL",
  "ELMHURST MEMORIAL HOSPITAL",
  "MERCY HOSPITAL SOUTH",
  "PHOENIX CHILDRENS HOSPITAL",
  "ADVENTHEALTH TAMPA",
  "TULANE UNIVERSITY HOSPITAL & CLINICS",
  "MERCY HOSPITAL FORT SMITH",
  "DANVILLE REGIONAL MEDICAL CENTER",
  "SHMC-RIVERBEND",
  "KADLEC REGIONAL MEDICAL CENTER",
  "NORTH AUSTIN MEDICAL CENTER",
  "SENTARA RMH MEDICAL CENTER",
  "RENOWN REGIONAL MEDICAL CENTER",
  "SWEDISHAMERICAN HOSPITAL",
  "MEMORIAL MEDICAL CENTER",
  "PRIMARY CHILDRENS HOSPITAL",
  "BAPTIST BEAUMONT HOSPITAL",
  "JERSEY SHORE UNIVERSITY MED CTR",
  "ST. DOMINIC-JACKSON MEMORIAL HOSP",
  "ASCENSION PROVIDENCE ROCHESTER HOSPI",
  "JOHNSON CITY MEDICAL CENTER",
  "TEWKSBURY HOSPITAL",
  "HOLSTON VALLEY HOSP & MED CTR",
  "COMMUNITY HOSPITAL OF SAN BERNARDINO",
  "ADVOCATE GOOD SAMARITAN HOSPITAL",
  "BRYN MAWR HOSPITAL",
  "YAKIMA VALLEY MEMORIAL HOSPITAL",
  "BAPTIST HEALTH LOUISVILLE",
  "FIRELANDS REGIONAL MEDICAL CENTER",
  "BERGEN NEW BRIDGE MEDICAL CENTER",
  "CAMBRIDGE HEALTH ALLIANCE",
  "CROUSE HOSPITAL",
  "SALEM HOSPITAL",
  "IU HEALTH BLOOMINGTON HOSPITAL",
  "SOUTH TEXAS HEALTH SYSTEM",
  "JACKSON HOSPITAL AND CLINIC INC",
  "GRANDVIEW HOSPITAL",
  "HURLEY MEDICAL CENTER",
  "TRUMBULL MEMORIAL HOSPITAL",
  "MIAMI JEWISH HEALTH SYSTEMS INC.",
  "BALTIMORE WASHINGTON MEDICAL CENTER",
  "THE UNITY HOSPITAL OF ROCHESTER",
  "LAFAYETTE GENERAL MEDICAL CENTER",
  "HOUSTON MEDICAL CENTER",
  "SAINT JOSEPH HOSPITAL",
  "NORTHWEST TEXAS HOSPITAL",
  "BLESSING HOSPITAL",
  "NORTH COLORADO MEDICAL CENTER",
  "MACNEAL HOSPITAL",
  "ASCENSION SACRED HEART BAY",
  "GLENS FALLS HOSPITAL",
  "ST. MARYS HOSPITAL & MEDICAL CENTER",
  "KFH - WOODLAND HILLS",
  "UNITED HOSPITAL",
  "SWEDISH COVENANT HEALTH",
  "INNOVIS HEALTH",
  "SCOTTISH RITE CHILDRENS MEDICAL CTR",
  "ELLIOT HOSPITAL",
  "GRANDVIEW MEDICAL CENTER",
  "OUR LADY OF LOURDES MEMORIAL HOSP",
  "WHITE COUNTY MEDICAL CENTER",
  "ADVENTIST HEALTH BAKERSFIELD",
  "CHI HEALTH CREIGHTON UNIVERSITY BERG",
  "ST. JOSEPHS MEDICAL CENTER",
  "SKYLINE MEDICAL CENTER",
  "AVERA ST. LUKES",
  "LAREDO MEDICAL CENTER",
  "FREDERICK MEMORIAL HOSPITAL",
  "NORTHWEST COMMUNITY HOSPITAL",
  "DUKE REGIONAL HOSPITAL",
  "ST. FRANCIS HOSPITAL",
  "MOUNT AUBURN HOSPITAL",
  "ST PATRICK HOSPITAL",
  "BRISTOL REGIONAL MEDICAL CENTER",
  "LAPORTE HOSPITAL",
  "JENNIE STUART MEDICAL CENTER",
  "WENTWORTH DOUGLASS HOSPITAL",
  "INTEGRIS SOUTHWEST MEDICAL CENTER",
  "PRESBYTERIAN ST LUKES MEDICAL CTR",
  "CABELL HUNTINGTON HOSPITAL",
  "OCALA REGIONAL MEDICAL CENTER",
  "PIEDMONT COLUMBUS REGIONAL MIDTOWN",
  "GENESYS REGIONAL MEDICAL CTR.",
  "ST. JOSEPH MEDICAL CENTER",
  "SHEPPARD & ENOCH PRATT HOSPITAL",
  "MERCYONE NORTH IOWA MEDICAL CENTER",
  "ATRIUM MEDICAL CENTER",
  "SENTARA NORTHERN VIRGINIA MED CTR",
  "KFH - SANTA CLARA",
  "ST MARY CORWIN MEDICAL CENTER",
  "NEW YORK-PRESBYTERIAN/BROOKLYN METHO",
  "MEDSTAR HARBOR HOSPITAL",
  "HOLY NAME HOSPITAL",
  "USA CHILDRENS AND WOMENS HOSPITAL",
  "ROCHESTER GENERAL HOSPITAL",
  "COMMUNITY MEDICAL CENTER",
  "AHC WHITE OAK MEDICAL CENTER",
  "MARY WASHINGTON HOSPITAL",
  "JOHN MUIR MEDICAL CENTER - CONCORD",
  "INOVA FAIR OAKS HOSPITAL",
  "THIBODAUX REGIONAL HEALTH SYSTEM",
  "WEST CHESTER HOSPITAL LLC",
  "PALMETTO GENERAL HOSPITAL",
  "FLAGSTAFF MEDICAL CENTER",
  "ST. PETERS HOSPITAL",
  "MERCY SAN JUAN MEDICAL CENTER",
  "MEMORIAL HOSPITAL OF TAMPA",
  "OLH-SHREVEPORT-ST. MARY MEDICAL CTR",
  "GERALD CHAMPION REGIONAL MEDICAL CTR",
  "KINGS DAUGHTERS HOSPITAL",
  "SPRINGFIELD REGIONAL MEDICAL CENTER",
  "COMMUNITY HOSPITAL SOUTH",
  "MIDMICHIGAN MEDICAL CENTER - ALPENA",
  "TERENCE CARDINAL COOKE HEALTH CARE",
  "NORTH ARKANSAS REGIONAL MEDICAL CTR",
  "MAUI MEMORIAL MEDICAL CENTER",
  "MOUNTAIN VIEW HOSPITAL",
  "BAYFRONT HEALTH PORT CHARLOTTE",
  "STEWARD ST. ANNES HOSPITAL",
  "EASTERN REGIONAL MEDICAL CENTER",
  "SYCAMORE HOSPITAL",
  "DESERT SPRINGS HOSPITAL MEDICAL CNTR",
  "SAINT FRANCIS MEMORIAL HOSPITAL",
  "NORTH FULTON REGIONAL HOSPITAL",
  "VIA CHRISTI HOSPITAL PITTSBURG INC.",
  "OUR LADY OF THE ANGELS HOSPITAL MC",
  "MERIT HEALTH WESLEY",
  "HARNETT HEALTH SYSTEM",
  "QUEEN OF THE VALLEY MEDICAL CENTER",
  "KFH - PANORAMA CITY",
  "BRANDYWINE HOSPITAL",
  "THE KINGSTON HOSPITAL",
  "COMMUNITY MEMORIAL HOSPITAL",
  "ST. MARYS REGIONAL HEALTH CENTER",
  "THE FINLEY HOSPITAL",
  "KFH - SAN LEANDRO",
  "WATSONVILLE COMMUNITY HOSPITAL",
  "PENOBSCOT BAY MEDICAL CENTER",
  "EMORY JOHNS CREEK HOSPITAL",
  "ALTA VIEW HOSPITAL",
  "OSF HEART OF MARY MEDICAL CENTER",
  "ST CHARLES MEDICAL CENTER",
  "CORPORACION DEL CENTRO CARDIOVASCULAR",
  "ST. ANTHONYS MEMORIAL HOSPITAL",
  "WOOD COUNTY HOSPITAL",
  "HALIFAX REGIONAL MEDICAL CENTER",
  "ADVENTHEALTH ZEPHYRHILLS",
  "MURRAY CALLOWAY COUNTY HOSPITAL",
  "HOMESTEAD HOSPITAL",
  "BLUFFTON REGIONAL MEDICAL CENTER",
  "GLENCOE REGIONAL HEALTH SERVICES",
  "ATRIUM HEALTH CLEVELAND",
  "MCLEOD LORIS SEACOAST HOSPITAL",
  "CENTER FOR BEHAVIORAL MEDICINE",
  "PONCA CITY MEDICAL CENTER",
  "LAYTON HOSPITAL",
  "PORTSMOUTH REGIONAL HOSPITAL",
  "HALIFAX REGIONAL HOSPITAL",
  "PELLA REGIONAL HEALTH CENTER",
  "UNITYPOINT HEALTH-MARSHALLTOWN",
  "INTERFAITH MEDICAL CENTER",
  "PECONIC BAY MEDICAL CENTER",
  "LAKE HURON MEDICAL CENTER",
  "PROVIDENCE CEDARS-SINAI TARZANA MEDICAL",
  "DOMINICAN HOSPITAL",
  "REDLANDS COMMUNITY HOSPITAL",
  "MEDSTAR MONTGOMERY MEDICAL CENTER",
  "CONWAY REGIONAL MEDICAL CENTER INC",
  "BAYLOR S&W MEDICAL CENTER - PLANO",
  "ADVENTHEALTH HEART OF FLORIDA",
  "HENRY COUNTY MEDICAL CENTER",
  "CRYSTAL CLINIC ORTHOPAEDIC CENTER",
  "JOHN RANDOLPH MEDICAL CENTER",
  "COOSA VALLEY MEDICAL CENTER",
  "SCRIPPS MEMORIAL HOSPITAL-ENCINITAS",
  "DOCTORS HOSPITAL",
  "ADVENTHEALTH WESLEY CHAPEL",
  "METHODIST HOSPITAL OF SACRAMENTO",
  "SSM HEALTH-ST. MARYS AUDRAIN",
  "EAST OHIO HOSPITAL LLC",
  "UAB MEDICAL WEST",
  "ARKANSAS STATE HOSPITAL",
  "THE OTIS R. BOWEN CENTER",
  "CHILDRENS MERCY HOSPITAL KANSAS",
  "PUTNAM HOSPITAL CENTER",
  "ST. FRANCIS REGIONAL MEDICAL CENTER",
  "ST. MARYS HOSPITAL",
  "PIEDMONT NEWTON HOSPITAL",
  "CARILION NEW RIVER VALLEY MED CENTER",
  "CALVERT MEMORIAL HOSPITAL",
  "FOUNTAIN VALLEY REG MEDICAL CENTER",
  "HENRY COUNTY MEMORIAL HOSPITAL",
  "MORRISTOWN-HAMBLEN HOSPITAL",
  "THE AROOSTOOK MEDICAL CENTER",
  "ST. MARY MEDICAL CENTER",
  "YORK HOSPITAL",
  "SILVER HILL HOSPITAL",
  "EPHRATA COMMUNITY HOSPITAL",
  "ASPIRUS RIVERVIEW HOSPITAL & CLINICS",
  "ACADIA HOSPITAL",
  "EMANUEL MEDICAL CENTER",
  "ROXBOROUGH MEMORIAL HOSPITAL",
  "HOPEDALE MEDICAL COMPLEX",
  "PALMS WEST HOSPITAL",
  "SAMARITAN ALBANY GENERAL HOSPITAL",
  "MEDICAL CITY WEATHERFORD",
  "WINDHAM COMMUNITY MEMORIAL HOSPITAL",
  "FAUQUIER HOSPITAL",
  "ADVENTHEALTH NEW SMYRNA BEACH",
  "LEXINGTON MEMORIAL HOSPITAL INC.",
  "MEDSTAR SOUTHERN MARYLAND HOSPITAL",
  "WEST CENTRAL GA REGIONAL HOSPITAL",
  "SPECTRUM HEALTH GERBER",
  "CIVISTA MEDICAL CENTER",
  "MOCCASIN BEND MENTAL HLTH INSTITUTE",
  "PARK CITY HOSPITAL",
  "SHASTA REGIONAL MEDICAL CENTER",
  "SUTTER DELTA MEDICAL CENTER",
  "TAWAS ST. JOSEPH HOSPITAL",
  "COLISEUM NORTHSIDE HOSPITAL",
  "CITY HOSPITAL AT WHITE ROCK",
  "ADVENTIST HEALTH ST. HELENA",
  "SOUTHWESTERN MEDICAL CENTER",
  "DELTA HEALTH-NORTHWEST REGIONAL",
  "SPECTRUM HEALTH PENNOCK HOSPITAL",
  "HOULTON REGIONAL HOSPITAL",
  "GOOD SHEPHERD MEDICAL CENTER",
  "VALLEY BAPTIST MEDICAL CENTER BROWNSVILLE",
  "CLINTON MEMORIAL HOSPITAL",
  "UT HEALTH ATHENS",
  "THREE RIVERS MEDICAL CENTER",
  "SAN GABRIEL VALLEY MEDICAL CENTER",
  "MILFORD HOSPITAL INC",
  "STEPHENS MEMORIAL HOSPITAL - CAH",
  "METHODIST H/C OLIVE BRANCH HOSPITAL",
  "NEVADA REGIONAL MEDICAL CENTER",
  "CHENANGO MEMORIAL HOSPITAL",
  "SPECTRUM HEALTH BIG RAPIDS",
  "PH LAURENS COUNTY HOSPITAL",
  "ANDERSON REGIONAL MEDICAL CENTER-SOUTH CAMPUS",
  "KETCHIKAN MEDICAL CENTER",
  "CLEVELAND CLINIC AVON HOSPITAL",
  "KINDRED HOSPITAL SPRING",
  "SCRIPPS GREEN HOSPITAL",
  "ROY L SCHNEIDER HOSPITAL",
  "CONTRA COSTA REGIONAL MEDICAL CENTER",
  "MERCY HOSPITAL ADA",
  "TAHOE FOREST HOSPITAL",
  "UNITED HOSPITAL DISTRICT",
  "FRANKLIN MEMORIAL HOSPITAL",
  "VANDERBILT TULLAHOMA-HARTON HOSPITAL",
  "FORT DUNCAN MEDICAL CENTER",
  "SOUTH FLORIDA BAPTIST HOSPITAL",
  "HOUSTON BEHAVIORAL HEALTHCARE",
  "HELENA REGIONAL MEDICAL CENTER",
  "SULLIVAN COUNTY COMMUNITY HOSPITAL",
  "WELLSPAN SURGERY AND REHAB HOSPITAL",
  "HARRISBURG MEDICAL CENTER INC.",
  "RIVERSIDE WALTER REED",
  "ST. LUKES WOOD RIVER MEDICAL CENTER",
  "SELECT SPECIALTY HOSPITAL - SAN DIEG",
  "MOUNT CARMEL NEW ALBANY HOSPITAL",
  "SUMMERSVILLE REGIONAL MED CENTER",
  "RIVERSIDE MED CTR",
  "SOUTHERN TN LAWRENCEBURG HOSPITAL",
  "SPECTRUM HEALTH REED CITY",
  "MULTICARE COVINGTON MEDICAL CENTER",
  "DELANO REGIONAL MED. CTR.",
  "LITTLE FALLS HOSPITAL",
  "SUMMIT MEDICAL CENTER",
  "NORTH LINCOLN HOSPITAL",
  "DONALSONVILLE HOSPITAL",
  "HIGHLAND COMMUNITY HOSPITAL",
  "ANDALUSIA REGIONAL HOSPITAL",
  "CHOWAN HOSPITAL INC.",
  "SHANDS LAKE SHORE",
  "CHIPPEWA COUNTY-MONTEVIDEO HOSPITAL",
  "JEFFERSON MEMORIAL HOSPITAL",
  "ST. LUKES BEHAVIORAL HEALTH CENTER",
  "AVERA HEART HOSPITAL OF SOUTH DAKOTA",
  "BAPTIST EMERGENCY HOSPITAL",
  "MARSHFIELD MEDICAL CENTER-MINOCQUA",
  "PORTER HOSPITAL",
  "QUENTIN N BURDICK MEMORIAL HOSPITAL",
  "MERCY REHABILITATION HOSPITAL - ST L",
  "INTL FALLS MEMORIAL HOSPITAL",
  "FLAMBEAU HOSPITAL MCHS",
  "COLORADO CANYONS HOSPITAL & MED CTR",
  "MERCY HOSPITAL OF FOLSOM",
  "CLAREMORE INDIAN HOSPITAL",
  "COLLEGE HOSPITAL INC",
  "WEST OAKS HOSPITAL",
  "MEDINA MEMORIAL HOSPITAL",
  "MONROE HOSPITAL",
  "DORMINY MEDICAL CENTER",
  "THE SPECIALTY HOSPITAL OF MERIDIAN",
  "BELTON REGIONAL MEDICAL CENTER",
  "BARTOW REGIONAL MEDICAL CENTER",
  "KONA COMMUNITY HOSPITAL",
  "GRANT MEMORIAL HOSPITAL",
  "TRANSYLVANIA COMMUNITY HOSPITAL",
  "ENGLEWOOD COMMUNITY HOSPITAL",
  "ASCENSION ST VINCENT SALEM HOSPITAL",
  "IRA DAVENPORT MEMORIAL HOSPITAL INC",
  "SANFORD ABERDEEN MEDICAL CENTER",
  "CHESTER RIVER HOSPITAL CENTER",
  "UH CONNEAUT MEDICAL CENTER",
  "TEN BROECK HOSPITAL - KMI",
  "CRAWFORD COUNTY MEMORIAL HOSPITAL",
  "LA PALMA INTERCOMMUNITY HOSPITAL",
  "SANFORD MEDICAL CENTER SHELDON",
  "RAPPAHANNOCK GENERAL HOSPITAL",
  "LIMESTONE MEDICAL CENTER",
  "ADVENTIST HEALTH REEDLEY",
  "ADVENTIST HEALTH TULARE",
  "MADISON HEALTH",
  "CURAHEALTH JACKSONVILLE LLC",
  "ST. JOSEPHS HOSPITAL-HIGHLAND IL",
  "COMMUNITY HEALTHCARE SYSTEM",
  "MINIDOKA MEMORIAL HOSPITAL",
  "COVINGTON COUNTY HOSPITAL",
  "PROWERS MEDICAL CENTER",
  "KFH - SAN RAFAEL",
  "BAYLOR ORTHOPEDIC AND SPINE HOSPITAL",
  "BLACK HILLS SURGICAL HOSPITAL LLP",
  "TEXAS HEALTH KAUFMAN",
  "ANDROSCOGGIN VALLEY HOSPITAL",
  "LINCOLN REGIONAL HOSPITAL",
  "SHELBY MEMORIAL HOSPITAL",
  "ASCENSION SETON SOUTHWEST",
  "ENCOMPASS HEALTH DEACONESS REHABILIT",
  "SANFORD HOSPITAL LUVERNE",
  "RIVER OAKS HOSPITAL",
  "DESERT PARKWAY BEHAVIORAL HEALTHCARE",
  "WHITESBURG ARH",
  "HEART HOSPITAL OF BAKERSFIELD",
  "SOUTH TEXAS SURGICAL HOSPITAL",
  "SIOUX FALLS SPECIALTY HOSPITAL",
  "BUCYRUS COMMUNITY HOSPITAL",
  "KINDRED HOSPITAL GREENSBORO",
  "BOONE MEMORIAL HOSPITAL",
  "LAURELWOOD HOSPITAL",
  "TRINITY MUSCATINE",
  "ENCOMPASS HEALTH REHABILITATION HOSP",
  "LAFAYETTE SURGICAL SPECIALTY HOSPITA",
  "KINDRED HOSPITAL LAS VEGAS",
  "GLENBEIGH HEALTH SOURCES",
  "WALDEN BEHAVIORAL CARE",
  "DOCTORS MEMORIAL",
  "HOCKING VALLEY",
  "WAR MEMORIAL HOSPITAL",
  "MERCYONE OELWEIN MEDICAL CENTER",
  "JERSEY SHORE HOSPITAL",
  "NY COMMUNITY HOSPITAL OF BROOKLYN",
  "CENTRAL LOUISIANA SURGICAL HOSPITAL",
  "WADLEY MEDICAL CENTER AT HOPE",
  "BARSTOW COMMUNITY HOSPITAL",
  "HARTGROVE HOSPITAL",
  "DOCTORS HOSPITAL OF MANTECA",
  "SOUTHCOAST BEHAVIORAL HEALTH",
  "WETZEL COUNTY HOSPITAL",
  "PEMBROKE HOSPITAL",
  "FOUR COUNTY COUNSELING CENTER",
  "VIA CHRISTI HOSP. WICHITA ST. TERESA",
  "MATHENY SCHOOL & HOSPITAL",
  "MERCY MEDICAL CENTER - NEW HAMPTON",
  "EAST LOS ANGELES DOCTORS HOSPITAL",
  "HARVARD MEMORIAL HOSPITAL",
  "WASHINGTON CO REG MED CTR",
  "CUMBERLAND MEMORIAL HOSPITAL",
  "LAWRENCE COUNTY MEMORIAL HOSPITAL",
  "HOLZER MEDICAL CENTER JACKSON",
  "MIMBRES MEMORIAL HOSPITAL",
  "MOAB REGIONAL HOSPITAL",
  "PERIMETER BEHAVIORIAL HOSPITAL OF AR",
  "AVERA ST. ANTHONYS HOSPITAL",
  "UKHS GREAT BEND CAMPUS",
  "CHRISTUS COUSHATTA HEALTH CARE CTR",
  "CANNON FALLS MEDICAL CENTER - MAYO",
  "JASPER MEMORIAL HOSPITAL",
  "CALAIS COMMUNITY HOSPITAL",
  "SAINT FRANCIS HOSPITAL VINITA",
  "MAGNOLIA REGIONAL HEALTH SYSTEM INC",
  "IOWA SPECIALTY HOSPITAL",
  "AHN HEMPFIELD NEIGHBORHOOD HOSPITAL",
  "SAUNDERS COUNTY HEALTH SERVICES",
  "OLNEY HAMILTON HOSPITAL DISTRICT",
  "EATON RAPIDS MEDICAL CENTER",
  "BAYLOR SCOTT & WHITE PFLUGERVILLE",
  "FIRSTHEALTH MONTGOMERY MEMORIAL CAH",
  "GLEN ROSE MEDICAL CENTER",
  "GREENE COUNTY GENERAL HOSPITAL",
  "S.E. LACKEY MEMORIAL HOSPITAL",
  "FREEMAN NEOSHO HOSPITAL",
  "ST. LUKES LAKESIDE HOSPITAL",
  "GOLDEN PLAINS COMMUNITY HOSPITAL",
  "ERLANGER BEHAVIORAL HEALTH",
  "TANNER MEDICAL CENTER ALABAMA INC.",
  "THE REHABILITATION INSTITUTE OF OHIO",
  "DOVER BEHAVIORAL HEALTH SYSTEM",
];

export const ownershipTypes = [
  "Voluntary Nonprofit, Other",
  "Voluntary Nonprofit, Church",
  "Governmental, City",
  "Governmental, State",
  "Governmental, Other",
  "Proprietary, Partnership",
  "Proprietary, Corporation",
  "Governmental, Hospital District",
  "Governmental, County",
  "Proprietary, Individual",
  "Proprietary, Other",
  "Governmental, City-County",
  "Governmental, Federal",
];

export const facilityTypes = [
  "Short Term Acute",
  "Childrens Hospital",
  "Psychiatric Hospital",
  "Long Term Hospital",
  "Rehabilitation Hospital",
  "Critical Access Hospital",
  "Other",
];

export const urban_rural_flag = [
  "Urban",
  "Rural",
]